(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/campaign-step/assets/javascripts/campaign-step.js') >= 0) return;  svs.modules.push('/components/lb-ui/campaign-step/assets/javascripts/campaign-step.js'); "use strict";

const TIMESPAN_1000MSEC = 1000;
const TIMESPAN_1MIN = TIMESPAN_1000MSEC * 60;
const TIMESPAN_1H = TIMESPAN_1MIN * 60;
const TIMESPAN_24H = TIMESPAN_1H * 24;

const getDateDiff = function (d1) {
  let d2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let olderDate;
  let newerDate;

  if (!d2) {
    d2 = new Date();
  }

  if (d1 < d2) {
    olderDate = d1;
    newerDate = d2;
  } else {
    olderDate = d2;
    newerDate = d1;
  }

  const unixDiff = newerDate - olderDate;
  const hourDiff = Math.floor(unixDiff / TIMESPAN_1H);
  const minutesDiff = Math.floor((unixDiff - hourDiff * TIMESPAN_1H) / TIMESPAN_1MIN);
  const secondsDiff = Math.floor((unixDiff - (hourDiff * TIMESPAN_1H + minutesDiff * TIMESPAN_1MIN)) / TIMESPAN_1000MSEC);
  return {
    hourDiff: "".concat(hourDiff).padStart(2, '0'),
    minutesDiff: "".concat(minutesDiff).padStart(2, '0'),
    secondsDiff: "".concat(secondsDiff).padStart(2, '0'),
    durationDiff: "PT".concat(hourDiff, "H").concat(minutesDiff, "M").concat(secondsDiff, "S"),
    lessThan24h: unixDiff < TIMESPAN_24H,
    unixDiff
  };
};

if (svs.isServer) {
  exports.getDateDiff = getDateDiff;
} else {
  var _svs$campaignStep, _svs$campaignStep$dat;

  if ((_svs$campaignStep = svs.campaignStep) !== null && _svs$campaignStep !== void 0 && (_svs$campaignStep$dat = _svs$campaignStep.data) !== null && _svs$campaignStep$dat !== void 0 && _svs$campaignStep$dat.campaignTimeStamp) {
    const campaignTimeStamp = new Date(svs.campaignStep.data.campaignTimeStamp);
    const campaignStepInterval = setInterval(() => {
      const now = new Date();

      if (campaignTimeStamp < now) {
        clearInterval(campaignStepInterval); 

        const campaignStepInfoEl = document.querySelector('.campaign-step-info');
        campaignStepInfoEl.innerText = 'Din kampanj har löpt ut';
      } else {
        const diffs = getDateDiff(campaignTimeStamp);
        const timeEl = document.querySelector('.campaign-step-info time');

        if (timeEl) {
          timeEl.dateTime = diffs.durationDiff;
          const hourPartEl = document.querySelector('.campaign-step-info .hour-part');
          hourPartEl.textContent = diffs.hourDiff;
          const minutesPartEl = document.querySelector('.campaign-step-info .minutes-part');
          minutesPartEl.textContent = diffs.minutesDiff;
          const secondsPartEl = document.querySelector('.campaign-step-info .seconds-part');
          secondsPartEl.textContent = diffs.secondsDiff;
        }
      }
    }, 1000);
  }

  setGlobal('svs.components.lbUi.CampaignStep', {
    getDateDiff
  });
}
 })(window);